import NextLink from 'next/link';

import { Modal } from '@frontendmentorio/design-system-v2';

export default function AccessibilityModal({ modal }) {
  return (
    <Modal modal={modal}>
      <Modal.Heading>How does the accessibility report work?</Modal.Heading>
      <p>
        When a solution is submitted, we use{' '}
        <NextLink
          className="underline hover:no-underline"
          href="https://www.npmjs.com/package/axe-core"
        >
          axe-core
        </NextLink>{' '}
        to run an automated audit of your code.
      </p>

      <p>
        This picks out common accessibility issues like not using semantic HTML
        and not having proper heading hierarchies, among others.
      </p>

      <p>
        This automated audit is fairly surface level, so we encourage to you
        review the project and code in more detail with accessibility best
        practices in mind.
      </p>
    </Modal>
  );
}
